import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-b-sc-in-computer-science',
  templateUrl: './b-sc-in-computer-science.component.html',
  styleUrls: ['./b-sc-in-computer-science.component.scss']
})
export class BScInComputerScienceComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
